import { Link } from "react-router-dom";

import { styled } from "../../../../styles";

export const BreadcrumbNav = styled("nav", {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "6px",
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$gray-80",
});

const crumbBase = {
  color: "$primary",
  textDecoration: "none",
  cursor: "pointer",

  "&:hover": {
    textDecoration: "underline",
  },
};

export const BreadcrumbLink = styled(Link, crumbBase);

/** For a step that navigates within the view rather than to a route. */
export const BreadcrumbButton = styled("button", {
  ...crumbBase,
  border: "none",
  background: "none",
  padding: 0,
  font: "inherit",
});

/** The page you are on — not a link. */
export const BreadcrumbCurrent = styled("span", {
  color: "$charcoal",
  fontWeight: 600,
});

export const BreadcrumbSeparator = styled("span", {
  color: "$gray-60",
});
